/**
 * H5P Standalone Example Application
 * Demonstrates how to load and render H5P Interactive Video content
 */

// Configuration for H5P standalone - environment aware
const isDevelopment = document.getElementById('h5p-development') !== null;
const h5pBasePath = isDevelopment ? './node_modules/h5p-standalone/dist' : './h5p-standalone';

const h5pConfig = {
    h5pJsonPath: './h5p-content',
    frameJs: `${h5pBasePath}/frame.bundle.js`,
    frameCss: `${h5pBasePath}/styles/h5p.css`,
    librariesPath: `${h5pBasePath}/h5p-libraries`,
    contentJsonPath: './h5p-content/content.json'
};

// Wait for DOM to be ready
document.addEventListener('DOMContentLoaded', function() {
    console.log('Initializing H5P Standalone Example...');

    // Initialize H5P
    initializeH5P();
});

/**
 * Initialize H5P content using h5p-standalone
 */
async function initializeH5P() {
    try {
        // Show loading indicator
        showLoading(true);

        // Load H5P content
        await loadH5PContent();

        console.log('H5P content loaded successfully!');

    } catch (error) {
        console.error('Error initializing H5P:', error);
        showError('Failed to load H5P content: ' + error.message);
    } finally {
        showLoading(false);
    }
}

/**
 * Load H5P content using H5PStandalone
 */
async function loadH5PContent() {
    try {
        // Check if H5PStandalone is available
        if (!window.H5PStandalone) {
            throw new Error('H5PStandalone is not loaded. Make sure main.bundle.js is included correctly.');
        }

        // Get the container element
        const element = document.getElementById('h5p-container');
        if (!element) {
            throw new Error('H5P container element not found');
        }

        // Configure H5P options
        const options = {
            h5pJsonPath: h5pConfig.h5pJsonPath,
            frameJs: h5pConfig.frameJs,
            frameCss: h5pConfig.frameCss
        };

        console.log('Initializing H5P with options:', options);

        // Create H5P instance
        const h5pInstance = new window.H5PStandalone.H5P(element, options);

        console.log('H5P instance created:', h5pInstance);

    } catch (error) {
        console.error('Error loading H5P content:', error);
        throw error;
    }
}

/**
 * Display content information as fallback
 */
function displayContentInfo(h5pData, contentData) {
    const container = document.getElementById('h5p-container');

    const infoHtml = `
        <div class="h5p-fallback">
            <h3>${h5pData.title}</h3>
            <p><strong>Content Type:</strong> ${h5pData.mainLibrary}</p>
            <p><strong>Language:</strong> ${h5pData.language}</p>

            <div class="content-details">
                <h4>Content Structure:</h4>
                <pre>${JSON.stringify(contentData, null, 2)}</pre>
            </div>

            <div class="instructions">
                <h4>Setup Instructions:</h4>
                <ol>
                    <li>Add a sample video file to <code>h5p-content/videos/sample-video.mp4</code></li>
                    <li>Make sure all H5P libraries are properly loaded</li>
                    <li>Serve the content from a web server (not file:// protocol)</li>
                </ol>
            </div>
        </div>
    `;

    container.innerHTML = infoHtml;
}

/**
 * Show/hide loading indicator
 */
function showLoading(show) {
    const loadingElement = document.getElementById('loading');
    if (loadingElement) {
        loadingElement.style.display = show ? 'block' : 'none';
    }
}

/**
 * Show error message
 */
function showError(message) {
    const container = document.getElementById('h5p-container');
    container.innerHTML = `
        <div class="error">
            <h3>Error Loading H5P Content</h3>
            <p>${message}</p>
            <div class="error-details">
                <h4>Troubleshooting Tips:</h4>
                <ul>
                    <li>Make sure you're serving the content from a web server</li>
                    <li>Check that all file paths are correct</li>
                    <li>Verify that h5p-standalone library is properly loaded</li>
                    <li>Ensure video files are accessible</li>
                </ul>
            </div>
        </div>
    `;
}

// Export functions for potential external use
window.H5PApp = {
    initialize: initializeH5P,
    loadContent: loadH5PContent,
    showError: showError
};